import ConsentForm from '@/components/forms/ConsentForm';

export default function Consent() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-muted">
            <ConsentForm />
        </div>
    );
}
